import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { baseTheme } from '~base-theme';
import typographyTheme from '../styles/typographyTheme';
import paragraphStyles from '../styles/paragraphStyles';
import paragraphLeadStyles from '../styles/paragraphLeadStyles';
var Paragraph = styled.p.withConfig({
  displayName: "Paragraph",
  componentId: "sc-1gk4m97-0"
})(["", " color:", ";margin-bottom:", ";", ""], paragraphStyles, function (_ref) {
  var theme = _ref.theme,
      colorValue = _ref.colorValue;
  return _get(theme, "base.colors." + colorValue, baseTheme.base.colors[colorValue]);
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'typography.paragraph.margin', typographyTheme.typography.paragraph.margin));
}, function (_ref3) {
  var lead = _ref3.lead;
  return lead && css(["", ""], paragraphLeadStyles);
});
export default Paragraph;